import React from 'react';
import SafeIcon from '../common/SafeIcon';

const InternalJobs = () => {
  const JOBS = [
    { id: 1, title: 'Senior Logistics Coordinator', dept: 'Operations', deadline: 'Apr 10, 2026', type: 'Promotion' },
    { id: 2, title: 'Lead Recruitment Specialist', dept: 'HR', deadline: 'Apr 15, 2026', type: 'Growth' },
    { id: 3, title: 'HSE Officer', dept: 'Safety', deadline: 'May 01, 2026', type: 'Specialized' },
  ];

  return (
    <div className="space-y-6">
      <div className="p-10 bg-gradient-to-br from-[#11469A] to-[#00AEEF] rounded-2xl text-white relative overflow-hidden shadow-lg">
        <div className="absolute top-0 right-0 p-10 opacity-10">
          <SafeIcon name="Briefcase" size={140} />
        </div>
        <div className="relative z-10 max-w-2xl">
          <h1 className="text-3xl font-extrabold mb-3">Internal Career Portal</h1>
          <p className="text-lg opacity-90 leading-relaxed font-medium">
            Grow your career within Resource & Manpower. We prioritize internal mobility and professional advancement.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {JOBS.map(job => (
          <div key={job.id} className="card p-6 border border-gray-100 hover:shadow-md transition-all group">
            <div className="flex justify-between items-start mb-4">
              <span className="bg-blue-50 text-[#11469A] text-[10px] font-bold px-2 py-1 rounded-lg uppercase tracking-wider border border-blue-100">{job.type}</span>
              <button className="text-gray-300 group-hover:text-[#11469A] transition-colors"><SafeIcon name="Share2" size={18} /></button>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-1">{job.title}</h3>
            <p className="text-sm text-gray-500 mb-6">{job.dept} · Apply by {job.deadline}</p>
            <div className="flex gap-2">
              <button className="flex-1 bg-[#11469A] text-white py-2.5 rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-[#0d3678] transition-colors">Apply Now</button>
              <button className="px-4 py-2.5 border border-gray-200 text-gray-600 rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-gray-50 transition-colors">Details</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InternalJobs;